// Planes (DEV-43). El catálogo (precios, textos, funciones) viene del backend
// (GET /plans); aquí solo vive lo que es propio de la app.

// Todavía no hay cobro en la app: "Quiero este plan" abre un correo a este buzón,
// el mismo canal oficial de la política de datos (legalDocuments.js).
export const PLANS_CONTACT_EMAIL = "support@athletain.com";

export const planPathFor = (role) => (role === "scout" ? "/scout/plan" : "/athlete/plan");

export const planContactHref = (plan, { fullName, email } = {}) => {
  const name = plan ? `${plan.audience === "scout" ? "Cazatalentos / Entrenador" : "Deportista"} ${plan.name}` : "Athletain";
  const subject = plan?.contact_only ? `Información sobre el plan ${name}` : `Quiero el plan ${name}`;
  const lines = [
    "Hola equipo Athletain,",
    "",
    plan?.contact_only
      ? `Me gustaría recibir información sobre el plan ${name}.`
      : `Me gustaría activar el plan ${name}${plan?.price_label ? ` (${plan.price_label})` : ""}.`,
    "",
    fullName ? `Nombre: ${fullName}` : null,
    email ? `Correo de mi cuenta: ${email}` : null,
  ].filter((line) => line !== null);
  return `mailto:${PLANS_CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join("\n"))}`;
};

/** 403 from a feature the current plan does not include. */
export const isPlanRequired = (error) => error?.code === "plan_required";

/** 429 from the assistant's per-plan daily limit (not the per-minute one). */
export const isDailyLimit = (error) =>
  error?.code === "rate_limited" && error?.details?.reason === "daily_limit";

/** Upgrade prompts only make sense when there is something better to buy. */
export const shouldOfferUpgrade = (error) =>
  isPlanRequired(error) || (isDailyLimit(error) && error?.details?.upgrade !== false);

/** "15 de noviembre de 2026", as a Colombian calendar date. */
export const formatPlanDate = (iso) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("es-CO", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "America/Bogota",
  });
};
